import axios from '@/utilities/axios-global'

export function GET_REVIEW_PROJECT(context, projectId) {
  return new Promise((resolve, reject) => {
    axios.get(`${context.rootState.user.baseApiUrl}/projects/${projectId}`).then(
      response => {
        context.commit('SET_REVIEW_PROJECT', response.data.project)
        context.commit('SET_PROJECTS_REBUTTALS', response.data.projectsRebuttals.map(e => ({ ...e, selectedCodeTypes: JSON.parse(e.selectedCodeTypes) })))
        context.commit('SET_REBUTTALS_NOTIFICATIONS', response.data.rebuttalsNotifications)
        context.commit('SET_PROJECTS_CODETYPELIST', response.data.codeTypeList)
        context.commit('SET_PROJECTS_REBUTTALS_BACKUP', JSON.parse(JSON.stringify(response.data.projectsRebuttals.map(e => ({ ...e, selectedCodeTypes: JSON.parse(e.selectedCodeTypes) })))))
        resolve()
      },
      error => {
        context.commit('SET_PROJECTS_REBUTTALS_BACKUP', [])
        console.log(error)
        reject(error)
      }
    )
  })
}

export function POST_NOTIFY_REBUTTAL_RECIPIENTS(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + `/projects/${payload.projectId}/${payload.rebuttalsNotificationid}/notify-rebuttal-recipients/`
    const body = {
      people: payload.people,
      notificationTemplateId: payload.notificationTemplateId != null ? payload.notificationTemplateId : null,
      customNotifyBody: payload.customNotifyBody != null ? payload.customNotifyBody : null
    }
    return axios.post(url, body).then(
      response => {
        context.commit('SET_PROJECTS_REBUTTALS', response.data.projectsRebuttals.map(e => ({ ...e, selectedCodeTypes: JSON.parse(e.selectedCodeTypes) })))
        context.commit('SET_PROJECTS_REBUTTALS_BACKUP', JSON.parse(JSON.stringify(response.data.projectsRebuttals.map(e => ({ ...e, selectedCodeTypes: JSON.parse(e.selectedCodeTypes) })))))
        resolve(response.data)
      },
      err => {
        console.log(err)
        reject(err)
      }
    )
  })
}

export function PUT_PROJECTS_REBUTTALS(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + `/projects/put-project-rebuttals/${payload.projectRebuttalId}`
    return axios.put(url, payload).then(
      response => {
        context.commit('SET_PROJECTS_REBUTTAL', response.data)
        resolve(response.data)
      },
      err => {
        console.log(err)
        reject(err)
      }
    )
  })
}

export function POST_PROJECTS_REBUTTALS(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + `/projects/post-project-rebuttals`
    return axios.post(url, payload.projectsRebuttals).then(
      response => {
        let responseData = {
          recordType: payload.recordType,
          projectsRebuttals: [response.data]
        }
        context.commit('SET_PROJECTS_REBUTTALS_SELECTEDCODETYPES', responseData)
        resolve(response.data)
      },
      err => {
        console.log(err)
        reject(err)
      }
    )
  })
}

export default {
  GET_REVIEW_PROJECT,
  POST_NOTIFY_REBUTTAL_RECIPIENTS,
  PUT_PROJECTS_REBUTTALS,
  POST_PROJECTS_REBUTTALS
}
